import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { XM_SITE_PENDING_APPLY_TPL_CODE, XM_SITE_PENDING_PRODUCT_CODE } from 'config/constants/sessionStorage'
import { write } from 'utils/cookieUtils'

export default function useLoginActionStorage() {
  const router = useRouter()
  const { templateCode, productCode } = router.query

  useEffect(() => {
    if (!!templateCode) {
      write({
        name: XM_SITE_PENDING_APPLY_TPL_CODE,
        value: templateCode as string,
        domain: process.env.NEXT_PUBLIC_COOKIE_ALL_DOMAIN,
      })
    }

    if (!!productCode) {
      write({
        name: XM_SITE_PENDING_PRODUCT_CODE,
        value: productCode as string,
        domain: process.env.NEXT_PUBLIC_COOKIE_ALL_DOMAIN,
      })
    }
  }, [templateCode, productCode])
}
